import dynamic from 'next/dynamic';
import { memo } from 'react';
import {
    Columns,
    Element,
    Image,
    Section,
    Title,
} from '@zmedia/bm-soccer-ui/components';
import { PLAYER_POSITION } from './constant';
import styles from './style.module.scss';
import { formatFromCustomStr, getDiffYear } from '@zmedia/bm-soccer-ui/utils/date';

const RadarChart = dynamic(
    () => import('@zmedia/bm-soccer-ui/modules/shared/components/chart'),
    {
        ssr: false,
    }
);

export function PlayerOverview(props: any) {
    const {
        position = {},
        height,
        weight,
        dateOfBirth,
        shirtNumber,
        market = {},
        country = {},
    } = props;
    const { main = {}, best = {}, other = {} } = position;

    return (
        <Columns className={styles['column-player']}>
            <Columns.Column>
                <Section>
                    <Title>Thông tin cơ bản</Title>
                    <Element className={styles['player-full-info']}>
                        {height > 0 && (
                            <Element className={styles['info']}>
                                <Element className={styles['text']}>
                                    Chiều cao
                                </Element>
                                <Element className={styles['subtext']}>
                                    {height} cm
                                </Element>
                            </Element>
                        )}
                        {weight > 0 && (
                            <Element className={styles['info']}>
                                <Element className={styles['text']}>
                                    Cân nặng
                                </Element>
                                <Element className={styles['subtext']}>
                                    {weight} kg
                                </Element>
                            </Element>
                        )}

                        {dateOfBirth && (
                            <Element className={styles['info']}>
                                <Element className={styles['text']}>
                                    {formatFromCustomStr(
                                        dateOfBirth.toString(),
                                        'YYYYMMDD',
                                        'DD [thg] MM, YYYY'
                                    )}
                                </Element>
                                <Element className={styles['subtext']}>
                                    {getDiffYear(
                                        dateOfBirth.toString(),
                                        'YYYYMMDD'
                                    )}{' '}
                                    tuổi
                                </Element>
                            </Element>
                        )}

                        {country.id && (
                            <Element className={styles['info']}>
                                <Element className={styles['text']}>
                                    Quốc gia
                                    <Image
                                        src={country.logo}
                                        alt={country.name}
                                    />
                                </Element>
                                <Element className={styles['subtext']}>
                                    {country.name}
                                </Element>
                            </Element>
                        )}

                        {shirtNumber && (
                            <Element className={styles['info']}>
                                <Element className={styles['text']}>
                                    Số áo
                                </Element>
                                <Element className={styles['subtext']}>
                                    {shirtNumber}
                                </Element>
                            </Element>
                        )}
                        {market.value && (
                            <Element className={styles['info']}>
                                <Element className={styles['text']}>
                                    Giá trị thị trường
                                </Element>
                                <Element className={styles['subtext']}>
                                    {market.value} {market.unit}
                                </Element>
                            </Element>
                        )}
                    </Element>
                </Section>
            </Columns.Column>
            <Columns.Column>
                <Section>
                    <Title>Vị trí</Title>
                    <Element className={styles['position-container']}>
                        <Element>
                            <Element>
                                <Title>Vị trí chính</Title>
                                {best.name || main.name}
                            </Element>

                            {other.name && (
                                <Element className={styles['sub-position']}>
                                    <Title>Vị trí khác</Title>
                                    {other.name}
                                </Element>
                            )}
                        </Element>
                        <Element className={styles['pic-position']}>
                            <Element className={styles['bg-img']}></Element>
                            <Element
                                className={styles['best-text']}
                                style={PLAYER_POSITION[best.id || main.id]}
                            >
                                {best.shortName || main.shortName}
                            </Element>
                            {other.shortName && (
                                <Element
                                    className={styles['sub-text']}
                                    style={PLAYER_POSITION[other.id]}
                                >
                                    {other.shortName}
                                </Element>
                            )}
                        </Element>
                    </Element>
                </Section>
            </Columns.Column>
            <Columns.Column>
                <RadarChart {...props} />
            </Columns.Column>
        </Columns>
    );
}

export default memo(PlayerOverview);
